import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { COLOR } from 'src/service/utils/constant/color'
import { guid } from 'src/service/utils'

const ErrorBoundaryPage = (): JSX.Element => {
  const navigate = useNavigate()

  const pageBackHandler = () => {
    navigate(-1)
  }
  const pageReloadHandler = () => {
    window.location.reload()
  }

  return (
    <ErrorBoundaryWrap>
      <ErrorContents>
        <ErrorIcon viewBox="0 0 48 48" aria-hidden>
          <circle cx="24" cy="24" r="20" fill="none" stroke={COLOR.gray50} strokeWidth="2" />
          <rect x="22" y="12" width="4" height="16" rx="2" fill={COLOR.gray50} />
          <circle cx="24" cy="34" r="2.5" fill={COLOR.gray50} />
        </ErrorIcon>
        <ErrorText>페이지를 찾을 수 없습니다.</ErrorText>
        <ErrorReloadButton type="button" onClick={pageReloadHandler}>
          새로고침
        </ErrorReloadButton>
        <ErrorPageBackButton type="button" onClick={pageBackHandler}>
          뒤로가기
        </ErrorPageBackButton>
        {window.location.href.includes('localhost') && (
          <LocalOnlyViewContainer>
            <p>로컬에서만 노출됩니다.</p>
            <button
              type="button"
              onClick={() =>
                window.location.replace(`${window.location.origin}/rop01/default/${guid()}/0`)
              }
            >
              기본가입창 바로가기
            </button>
          </LocalOnlyViewContainer>
        )}
      </ErrorContents>
    </ErrorBoundaryWrap>
  )
}

export default ErrorBoundaryPage

const ErrorBoundaryWrap = styled.div`
  min-height: 100vh;
  width: 100%;
  max-width: 492px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${COLOR.white};
`

const ErrorContents = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 320px;
  width: 100%;
  margin: 0 auto;
  padding: 24px 16px;
`

const ErrorIcon = styled.svg`
  width: 48px;
  height: 48px;
  margin: 0 auto;
`

const ErrorText = styled.p`
  margin-top: 28px;
  margin-bottom: 70px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: ${COLOR.gray50};
`

const ErrorPageButton = styled.button`
  width: 260px;
  margin: 0 auto;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  cursor: pointer;
  background: ${COLOR.white};
`

const ErrorReloadButton = styled(ErrorPageButton)`
  color: ${COLOR.gray70};
  border: 1px solid ${COLOR.gray20};
  height: 38px;
  margin-bottom: 10px;
`

const ErrorPageBackButton = styled(ErrorPageButton)`
  color: ${COLOR.gray40};
  height: 38px;
`

const LocalOnlyViewContainer = styled.section`
  margin-top: 50px;
  padding: 16px;
  border-radius: 20px;
  border: 2px dotted ${COLOR.gray70};
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: ${COLOR.gray90};

  > button {
    background-color: ${COLOR.gray70};
    border-radius: 20px;
    padding: 10px;
    color: ${COLOR.white};
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
  }
`
